var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 83,
    viewBox: "0 0 108 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.15283,
    width: 108,
    height: 80,
    fill: "#181C24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3165 22.6528H70.6765V30.5728H58.3165V64.6528H49.6765V30.5728H37.3165V22.6528Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyPoster);
export default __webpack_public_path__ + "static/media/DummyPoster.4b4b619efef9793d9dad894b8a1675bf.svg";
export { ForwardRef as ReactComponent };